// Общий фетч манифеста контента для экранов меты (карта / коллекция / достижения).
// Шейп ответа — api/dto.ts (единый с loadGate PlayScreen: шов web↔backend).

import { useEffect, useState } from 'react';
import type { Manifest } from '@/api/dto';
import { routes } from '@/api/routes';

// реэкспорт: экраны меты и story/collection исторически берут типы отсюда
export type { Manifest, ManifestLevel, ManifestWorld } from '@/api/dto';

// манифест — один на сессию: кэш в модульной промисе (ср. api/assetsCatalog.ts),
// чтобы карта/плеер/логин не дёргали бэкенд на каждый маунт; фейл НЕ кэшируем —
// следующий маунт запросит снова
let manifestPromise: Promise<Manifest> | null = null;

export function loadManifest(): Promise<Manifest> {
  if (!manifestPromise) {
    manifestPromise = fetch(routes.manifest, { credentials: 'include' }).then(async (r) => {
      if (!r.ok) throw new Error(`manifest ${r.status}`);
      return (await r.json()) as Manifest;
    });
    manifestPromise.catch(() => { manifestPromise = null; });
  }
  return manifestPromise;
}

/** Сброс кэша манифеста (тесты — ср. resetAssetsCatalog; на будущее — рефетч
 *  после событий, меняющих контент: покупка, публикация уровня). */
export function invalidateManifest(): void { manifestPromise = null; }

export function useManifest(): { manifest: Manifest | null; error: string | null } {
  const [manifest, setManifest] = useState<Manifest | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadManifest()
      .then((m) => { if (!cancelled) setManifest(m); })
      .catch((e) => { if (!cancelled) setError(e instanceof Error ? e.message : String(e)); });
    return () => { cancelled = true; };
  }, []);

  return { manifest, error };
}
